import { Route, Routes as RoutesSwitch } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import PrivateRoute from "./components/PrivateRoute";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import PaintingPage from "./pages/PaintingPage";
import About from "./pages/About";
import Press from "./pages/Press";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import AdminAddPainting from "./pages/Admin/AdminAddPainting";
import AdminEditPainting from "./pages/Admin/AdminEditPainting";
import {GALLERY, ABOUT, PRESS, CONTACT, ADMIN_LOGIN, ADMIN, PAINTINGPAGE, ADMINADDPAINTING, ADMINEDITPAINTING} from "./constants/routes";

const Routes = () => {
    return (
        <RoutesSwitch>
            <Route path="/" element={<Layout />} >
                <Route index element={<Home/>}/>
                <Route path={GALLERY} element={<Gallery/>}/>
                <Route path={PAINTINGPAGE} element={<PaintingPage />} />
                <Route path={ABOUT} element={<About/>}/>
                <Route path={PRESS} element={<Press/>}/>
                <Route path={CONTACT} element={<Contact/>}/>
                <Route path={ADMIN_LOGIN} element={<AdminLogin/>}/>
                <Route path={ADMIN} element={
                    <PrivateRoute>
                        <AdminDashboard />
                    </PrivateRoute>}>
                    <Route path={ADMINADDPAINTING} element={<AdminAddPainting />} />
                    <Route path={ADMINEDITPAINTING} element={<AdminEditPainting />} />
                </Route>
            </Route>
        </RoutesSwitch>
    );
};

export default Routes;